import { H2, View, YStack } from 'tamagui'
import { AppLayout } from '@layouts/AppLayout'
import { LoadingScreen } from '@components/LoadingScreen'
import { EmptyStateComponent } from '@components/EmptyStateComponent'
import { AvatarSection } from '@components/Profile/AvatarSection'
import { PersonalDataSection } from '@components/Profile/PersonalDataSection'
import { PasswordSection } from '@components/Profile/PasswordSection'
import { SettingsSection } from '@components/Profile/SettingsSection'
import { NotificationsSection } from '@components/Profile/NotificationsSection'
import { CustomFieldsSection } from '@components/Profile/CustomFieldsSection'
import { useComponentTranslation } from '@hooks/useComponentTranslation'
import { useGetProfile } from '@services/api/graphql/queries/getProfile'

export function ProfileScreen() {
  const { t } = useComponentTranslation('Profile')
  const { profile, loading } = useGetProfile()

  if (loading) return <LoadingScreen />

  if (!profile) {
    return (
      <AppLayout backRoute={{ label: t('title') }}>
        <View flex={1}>
          <EmptyStateComponent
            title={t('emptyTitle')}
            description={t('empty')}
            displayButton={false}
          />
        </View>
      </AppLayout>
    )
  }

  return (
    <AppLayout backRoute={{ label: t('title') }}>
      <YStack
        marginTop={122}
        paddingHorizontal="$size.spacing-xs"
        gap="$size.spacing-md"
        flex={1}
        $gtSm={{ paddingHorizontal: '$size.spacing-xsl' }}
      >
        <H2 color="$text-primary" fontSize="$font-size-md" ff="$mulishBold">
          {t('title')}
        </H2>

        <AvatarSection coverImageUrl={profile.coverImageUrl} />
        <PersonalDataSection profile={profile} />
        <PasswordSection />
        <SettingsSection locale={profile.locale} />
        <NotificationsSection />
        {!!profile.customFields?.length && (
          <CustomFieldsSection fields={profile.customFields} />
        )}
      </YStack>
    </AppLayout>
  )
}
